import React from 'react'

// Third Party
import styled, { css } from 'styled-components'

interface TitleProps {
  children?: any
  className?: string
  small?: boolean
}

const StyledTitle = styled.div<{ small?: boolean }>`
  ${({ small }) =>
    small
      ? css`
          @media screen and (min-width: 992px) {
            font-size: 45px;
            line-height: 45px;
          }

          @media screen and (max-width: 991px) {
            font-size: 26px;
            line-height: 35px;
          }
        `
      : `
      @media screen and (min-width: 992px) {
    font-size: 100px;
    line-height: 94px;
    margin-bottom: -15px !important;
  }

  @media screen and (max-width: 991px) {
    font-size: 45px;
    line-height: 45px;
    margin-bottom: -5px !important;
    margin-left: 20px;
  }

  @media screen and (max-width: 575px) {
    font-size: 36px;
    line-height: 45px;
    margin-bottom: -5px !important;
    margin-left: 20px;
  }
    `}

  font-family: ${({ theme }) => theme.font.family.secondary};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  color: ${({ theme }) => theme.color.dark};
  opacity: 0.15;
  z-index: -1;
  position: relative;

  & p,
  & h1,
  & h2,
  & h3 {
    font-size: 100px;
    line-height: 94px;
    font-family: ${({ theme }) => theme.font.family.secondary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.dark};
    margin-bottom: -15px !important;

    @media screen and (max-width: 991px) {
      font-size: 45px;
      line-height: 45px;
      margin-bottom: -5px !important;
      margin-left: 20px;
    }
  }
`

function Title({ children, className, small }: TitleProps) {
  return (
    <StyledTitle className={className} small={small}>
      {children}
    </StyledTitle>
  )
}

export default Title
